import { inject, Injectable } from '@angular/core';
import { CockpitDateFilterStateService } from './cockpit-date-filter-state.service';

export interface CockpitFilterState {
  id_plaque?: number;
  id_affaire?: number;
  id_affaire_only?: number;
  id_point_relais?: number;
  id_agent?: number;
}

const SESSION_KEY = 'cockpit-filter-state';

const GPS_FILTER_KEYS: (keyof CockpitFilterState)[] = ['id_plaque', 'id_affaire', 'id_affaire_only', 'id_point_relais', 'id_agent'];

@Injectable({ providedIn: 'root' })
export class CockpitFilterStateService {
  private readonly dateState = inject(CockpitDateFilterStateService);

  getState(): CockpitFilterState {
    const saved = sessionStorage.getItem(SESSION_KEY);
    return saved ? JSON.parse(saved) : {};
  }

  setState(state: CockpitFilterState): void {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(state));
  }

  clearState(): void {
    sessionStorage.removeItem(SESSION_KEY);
    this.dateState.clearValue();
  }

  hasActiveState(): boolean {
    const state = this.getState();
    return GPS_FILTER_KEYS.some((key) => state[key] !== undefined);
  }

  /**
   * Retourne les params GPS présents dans les queryParams de l'URL.
   * Utile pour les resolvers afin de synchroniser l'état.
   */
  extractFromQueryParams(queryParams: Record<string, string>): CockpitFilterState {
    const state: CockpitFilterState = {};

    if (queryParams['id_plaque']) state.id_plaque = +queryParams['id_plaque'];
    if (queryParams['id_affaire']) state.id_affaire = +queryParams['id_affaire'];
    if (queryParams['id_affaire_only']) state.id_affaire_only = +queryParams['id_affaire_only'];
    if (queryParams['id_point_relais']) state.id_point_relais = +queryParams['id_point_relais'];
    if (queryParams['id_agent']) state.id_agent = +queryParams['id_agent'];

    return state;
  }
}
